import React from 'react';
import { useTheme } from 'styled-components';

import { IIconProps } from './TIcon';

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function DeviceIcon({ color: colorProp }: IIconProps) {
  const theme = useTheme();

  const color = colorProp || theme.colors.chartChartBlueSecondary2100;

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 1V1.5C10 2.05312 9.55312 2.5 9 2.5H7C6.44688 2.5 6 2.05312 6 1.5V1H5C4.44687 1 4 1.44687 4 2V14C4 14.5531 4.44687 15 5 15H11C11.5531 15 12 14.5531 12 14V2C12 1.44687 11.5531 1 11 1H10ZM9 1H7V1.5H9V1ZM3 2C3 0.896875 3.89688 0 5 0H11C12.1031 0 13 0.896875 13 2V14C13 15.1031 12.1031 16 11 16H5C3.89688 16 3 15.1031 3 14V2Z"
        fill={color}
      />
      <path
        d="M9 12.5H7C6.725 12.5 6.5 12.725 6.5 13C6.5 13.275 6.725 13.5 7 13.5H9C9.275 13.5 9.5 13.275 9.5 13C9.5 12.725 9.275 12.5 9 12.5Z"
        fill={color}
      />
    </svg>
  );
}

export default DeviceIcon;
